import type { Reducer } from 'react';
import type { ElementalPageState } from './ElementalPageContext';

export interface ElementalPageActions {
    type: 'toggleModal' | 'setURL' | 'setMeetingBooked';
    value?: string | boolean;
}

export const ElementalPageReducer: Reducer<
    ElementalPageState,
    ElementalPageActions
> = (state, action) => {
    switch (action.type) {
        case 'toggleModal': {
            return {
                ...state,
                modalOpen:
                    action.value !== undefined
                        ? (action.value as boolean)
                        : !state.modalOpen,
            };
        }
        case 'setURL': {
            return { ...state, demoURL: action.value as string };
        }
        case 'setMeetingBooked': {
            return { ...state, meetingBooked: true };
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
};
